/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

var props = {
  animation: {
    type: String,
    "default": "slide",
    validator: function validator(val) {
      if (!val) return true;
      return ["slide", "fade"].includes(val);
    }
  },
  autoplay: {
    type: Boolean,
    "default": true
  },
  current: {
    type: Number,
    "default": 0
  },
  defaultCurrent: {
    type: Number,
    "default": 0
  },
  direction: {
    type: String,
    "default": "horizontal",
    validator: function validator(val) {
      if (!val) return true;
      return ["horizontal", "vertical"].includes(val);
    }
  },
  duration: {
    type: Number,
    "default": 300
  },
  height: {
    type: Number
  },
  interval: {
    type: Number,
    "default": 5e3
  },
  loop: {
    type: Boolean,
    "default": true
  },
  navigation: {
    type: [Object, Function]
  },
  stopOnHover: {
    type: Boolean,
    "default": true
  },
  theme: {
    type: String,
    "default": "light",
    validator: function validator(val) {
      if (!val) return true;
      return ["light", "dark"].includes(val);
    }
  },
  trigger: {
    type: String,
    "default": "hover",
    validator: function validator(val) {
      if (!val) return true;
      return ["hover", "click"].includes(val);
    }
  },
  type: {
    type: String,
    "default": "default",
    validator: function validator(val) {
      if (!val) return true;
      return ["default", "card"].includes(val);
    }
  },
  onChange: Function
};

export { props as default };
//# sourceMappingURL=props.js.map
